import './HeadQuarters.css'

const HeadQuarters = ({ headQuartersRef }) => {
    return (
        <section className='content-container headQuarters' ref={headQuartersRef} >
            <div className='headQuarters-background'></div>
            <aside>
                <h2>CORPORATE HQ<span>.</span></h2>
                <article>
                    <p>16171 S. Bringhurst Blvd.</p>
                    <p>Suite 100</p>
                    <p>Bluffdale, Utah 84065</p>
                </article>
                <img src='https://pic.onlinewebfonts.com/svg/img_467274.png' alt='utah-outline' />
            </aside>
        </section>
    )
}

export default HeadQuarters
